import React, { useEffect } from 'react';
import './LandingPage.css';

/**
 * LandingPage - ルートドメインアクセス時の製品紹介ページ
 */
const LandingPage = () => {
    useEffect(() => {
        document.title = 'キャリアパイロット - 採用の最前線を、AIで加速する。';
    }, []);
    return (
        <div className="landing-page">
            <div className="landing-content">
                <div className="landing-logo">
                    <img src="/career-pilot.png" alt="Career Pilot" />
                </div>

                <h1 className="landing-tagline">
                    採用の最前線を、AIで加速する。
                </h1>

                <p className="landing-description">
                    キャリアパイロットは、人材コンサルタントのための AI パートナーです。<br />
                    候補者との面談から推薦まで、あらゆる業務プロセスをスマートに支援します。
                </p>

                <p className="landing-description">
                    面談音声をアップロードするだけで、AIが文字起こしと要約を自動生成。<br />
                    面談内容の振り返り分析や、企業向け推薦文の作成まで、<br />
                    これまで時間をかけていた業務を大幅に効率化します。
                </p>

                <p className="landing-description">
                    組織ごとに独立した環境で、安全にご利用いただけます。<br />
                    プロンプトのカスタマイズにも対応し、貴社の業務フローに最適化が可能です。
                </p>

                <div className="landing-separator" />

                <div className="landing-guide">
                    <div className="landing-guide-label">ログインについて</div>
                    <p className="landing-guide-text">
                        本サービスのご利用には、組織ごとに発行される専用URLからアクセスしてください。<br />
                        専用URLがご不明な場合は、組織の管理者にお問い合わせください。
                    </p>
                </div>

                <div className="landing-footer">
                    © {new Date().getFullYear()} キャリアパイロット
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
